import moment from 'moment';
import { STATE } from '../../../storeConstants';
import { buildPaymentData, payment } from '../../../util/formula';

const initialDownpayment = 855000;
const initialPrinciple = 85500000;
const initialTerm = 360;
const intitialInterestRate = 0.038;
const initialStartDate = moment();
const initialAnnualAmount = 0;
const initialOneTimeAmount = 0;
const initialMonthlyExtraAmount = 0;

function initPaymentData() {
  const initialPaymentAmount = payment({
    INTEREST_RATE: intitialInterestRate,
    PRINCIPLE: initialPrinciple,
    DOWNPAYMENT: initialDownpayment,
    TERM: initialTerm,
    MODIFY_TERM: 0,
    PAYMENT_DATA: { length: initialTerm }

  });

  const initialState = {
    ERRORS: {},
    PRINCIPLE: initialPrinciple,
    DOWNPAYMENT: initialDownpayment,
    INTEREST_RATE: intitialInterestRate,
    PAYMENT_NUMBER: 0,
    PAYMENT: initialPaymentAmount,
    START_DATE: initialStartDate,
    ONE_TIME_PAYMENT_AMOUNT: initialOneTimeAmount,
    ANNUAL_PAYMENT_AMOUNT: initialAnnualAmount,
    MODIFIED_TERM: initialTerm,
    EXTRA_MONTHLY_PAYMENT_AMOUNT: initialMonthlyExtraAmount,
    PAYMENT_DATA: { length: 360 }
  };
  
  return buildPaymentData({ ...initialState });
}
export default {
  [STATE.ERRORS]: {},
  [STATE.EXTRA_MONTHLY_PAYMENT_AMOUNT]: initialMonthlyExtraAmount,
  [STATE.DOWNPAYMENT]: initialDownpayment,
  [STATE.PRINCIPLE]: initialPrinciple,
  [STATE.TERM]: initialTerm,
  [STATE.INTEREST_RATE]: intitialInterestRate,
  [STATE.MODIFY_TERM]: 0,
  [STATE.CHART_SELECTOR_PERCENTAGE_X]: 0,
  [STATE.POINT_RADIUS]: [],
  [STATE.INTERVAL]: 12,
  [STATE.CHART_SELECTOR_SNAP_X]: 0,
  [STATE.START_DATE]: moment(),
  [STATE.ANNUAL_PAYMENT_AMOUNT]: initialAnnualAmount,
  [STATE.ONE_TIME_PAYMENT_AMOUNT]: initialOneTimeAmount,
  [STATE.EXTRA_PAYMENT_DATE]: moment(),
  [STATE.ANNUAL_PAYMENT_DATE]: 'January',
  [STATE.ONE_TIME_PAYMENT_DATE]: moment(),
  [STATE.CHART_CLICK_INDEX]: 0,
  [STATE.PAYMENT_DATA]: initPaymentData(),
  [STATE.INSURANCE_COST]: 0,
  [STATE.PROPERTY_TAX]: 0,
  [STATE.HOA_FEES]: 0,
  [STATE.CURRENT_DISPLAY]: 'PAYMENT_BREAKDOWN',

};
